<template>

    <div class="mt-2">
        <div style="padding-top:15px;">
            <button @click="createDemo" type="button" class="btn btn-sm btn-primary float-right ml-2"
                style=" color:white; background-color:#48a6a6 ;padding: 8px 25px;cursor: pointer;">Add Task
            </button>
            <div class="form-group" style="float:right; margin-left:120px;">
                <download-excel id="excel" class="btn btn-sm btn-outline-light"
                    style=" color:#48a6a6 ; border:1px solid #48a6a6; padding: 8px 13px; margin-right: 6px;cursor: pointer;"
                    :name="excelFileName" :data="demoRequests" :fields="json_fields">
                    Excel Download
                </download-excel>
            </div>
        </div>
        <div class="float-left">
            <h4 class="font-weight-bold mt-2">Tasks</h4>
            <div class="row m-0 p-0">
                <a href="/" style="margin-top: -3px;">
                    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7.10302 0.473538C6.91735 0.298002 6.67153 0.200195 6.41602 0.200195C6.16051 0.200195 5.91469 0.298002 5.72902 0.473538L0.885016 5.05154C0.736698 5.19189 0.618598 5.36105 0.537952 5.54865C0.457307 5.73625 0.415814 5.93834 0.416016 6.14254V11.7125C0.416281 12.1102 0.574434 12.4915 0.85571 12.7726C1.13699 13.0536 1.51836 13.2115 1.91602 13.2115H3.41602C3.81384 13.2115 4.19537 13.0535 4.47668 12.7722C4.75798 12.4909 4.91602 12.1094 4.91602 11.7115V9.21154C4.91602 9.07893 4.9687 8.95175 5.06246 8.85798C5.15623 8.76422 5.28341 8.71154 5.41602 8.71154H7.41602C7.54862 8.71154 7.6758 8.76422 7.76957 8.85798C7.86334 8.95175 7.91602 9.07893 7.91602 9.21154V11.7115C7.91602 12.1094 8.07405 12.4909 8.35536 12.7722C8.63666 13.0535 9.01819 13.2115 9.41602 13.2115H10.916C11.3138 13.2115 11.6954 13.0535 11.9767 12.7722C12.258 12.4909 12.416 12.1094 12.416 11.7115V6.14154C12.416 5.93743 12.3742 5.73549 12.2934 5.54807C12.2126 5.36065 12.0944 5.19169 11.946 5.05154L7.10302 0.471538V0.473538Z"
                            fill="#48a6a6" />
                    </svg>
                </a>
                <span style="margin: -3px 12px 0 12px;">
                    <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.227539 1.79558L1.27235 0.750765L6.22754 5.70595L1.27235 10.6611L0.227539 9.61632L4.13791 5.70595L0.227539 1.79558Z" fill="#9A9AB0" />
                    </svg>
                </span>
                <breadcrumbs />
            </div>
        </div>
        <br>
        <br>
        <br><br>

        <div class="card card-body col-12 mx-auto" style="border-radius:10px;">
            <div class="hide-scroll" style="overflow-y:auto;">
                <!-- Table     -->
                <table class="table table-hover text-center px-0 custom-table-height" id="dataTable" width="100%"
                    cellspacing="0">
                    <thead style="">
                        <tr
                            style="color:#48a6a6;background-color:#f4f8fa; border-bottom:1.1px solid #93a8d6; border-top:1.1px solid #93a8d6;">
                            <td> Name
                                <font-awesome-icon :icon="['fas', 'sort']" />
                            </td>
                            <td>Phone</td>
                            <td>Company
                                <font-awesome-icon :icon="['fas', 'sort']" />
                            </td>
                            <td>Email
                                <font-awesome-icon :icon="['fas', 'sort']" />
                            </td>
                            <td>Country</td>
                            <td>Address</td>
                            <td>Customer Interest</td>
                            <td>Status
                                <font-awesome-icon :icon="['fas', 'sort']" />
                            </td>
                            <td class="text-right"> Actions</td>
                        </tr>
                    </thead>
                    <tbody class="text-center" v-for="index in 15" :key="index">
                        <tr class="text-center">
                            <!-- name -->
                            <td class="text-primary">Awais</td>
                            <!-- phone -->
                            <td>
                                03413745187
                            </td>
                            <!-- company -->
                            <td>Foxtek</td>
                            <!-- email -->
                            <td> mr.awaisdanish@gmail.com</td>
                            <!-- country name -->
                            <td>Pakistan</td>
                            <!-- Address -->
                            <td>johar Town</td>
                            <!-- Interest -->
                            <td>
                                <button
                                    class="btn btn-sm btn-outline-success px-4 rounded-pill font-weight-bold text-success"
                                    style="background-color:#EBF7DF">Hyper</button>
                            </td>
                            <!-- Status -->
                            <td style="color:#A682B2; font-weight:bold;">
                                Data Migration
                            </td>
                            <!-- Actions -->
                            <td align="right">
                                <button @click="showOnboarding(index)" class="btn btn-sm" type="button"
                                    data-toggle="collapse" data-target="#boarding" aria-expanded="false"
                                    aria-controls="boarding">
                                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4.66113 12.4307L7.99864 15.7682L11.3362 12.4307" stroke="#48a6a6"
                                            stroke-width="1.5" />
                                        <path d="M11.3359 4.82324L7.99843 1.48573L4.66092 4.82324" stroke="#48a6a6"
                                            stroke-width="1.5" />
                                        <line x1="-0.000976497" y1="8.53955" x2="15.9991" y2="8.53955" stroke="#48a6a6"
                                            stroke-width="1.5" />
                                    </svg>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import onBoardingTable from "./on_boarding_table";
    export default {
        name: 'on-boarding',
        components: {
            onBoardingTable,
        },
        data: function () {
            return {
                excelFileName:"task.xls",
            }
        },


        computed: {

        },


        created: function () {

        },

        watch: {

        },
        methods: {
        }
    }
</script>
